import type { ReactNode } from 'react'
import { cn } from '../../utils/cn'

export interface EmptyStateProps {
  /** Material Symbols glyph name. */
  icon?: string
  title: ReactNode
  body?: ReactNode
  /** Usually a <Button>. */
  action?: ReactNode
  className?: string
}

export function EmptyState({ icon = 'inbox', title, body, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-xl border border-primary/10 bg-surface-container-low px-margin-mobile py-16 text-center md:px-gutter',
        className,
      )}
    >
      <span className="material-symbols-outlined mb-4 text-[32px] text-outline-variant">{icon}</span>
      <h3 className="font-display text-headline-sm text-on-surface">{title}</h3>
      {body && <p className="mt-2 max-w-md font-body-md text-body-md text-on-surface-variant">{body}</p>}
      {action && <div className="mt-8">{action}</div>}
    </div>
  )
}
